// extracted by mini-css-extract-plugin
export var border = "_1x-8";
export var brand = "_1x-t";
export var button = "_1x-l";
export var center = "_1x-a";
export var centered = "_1x-6";
export var closeButton = "_1x-c";
export var disabledWrapper = "_1x-m";
export var error = "_1x-p";
export var extraLarge = "_1x-4";
export var extraSmall = "_1x-1";
export var fill = "_1x-i";
export var footer = "_1x-h";
export var footerAction = "_1x-j";
export var footerButtons = "_1x-k";
export var header = "_1x-7";
export var headerWithClose = "_1x-d";
export var icon = "_1x-o";
export var info = "_1x-s";
export var inline = "_1x-9";
export var large = "_1x-3";
export var main = "_1x-e";
export var modal = "_1x-0";
export var nearFull = "_1x-5";
export var neutral = "_1x-u";
export var noPadding = "_1x-g";
export var none = "_1x-v";
export var scrollable = "_1x-f";
export var small = "_1x-2";
export var success = "_1x-r";
export var tight = "_1x-n";
export var titleIcon = "_1x-b";
export var warn = "_1x-q";